import { useContext } from 'react'
import { useSelector } from 'react-redux'
import { ModalContext, ModalKey } from 'components/Modals/ModalContext'
import trainingPeaksAppIcon from 'media/integrations/training_peaks/TrainingPeaks_App_Icon.jpg'

export default function TrainingPeaksWorkoutCalendarItem({
    timescale = 'block',
    trainingPeaksWorkout = null
}) {

    const { ShowModal } = useContext(ModalContext)

    const userId = useSelector(state => state.user.id)

    if (trainingPeaksWorkout === null) return null

    const GetTailwindCssClassName = () => {
        if (timescale === 'week') {
            return 'min-w-0 bg-blue-50 border-t-[3px] border-blue-400 w-full p-1 rounded-md shadow cursor-pointer hover:shadow-md'
        }

        return 'min-w-0 py-0.5 px-1 rounded-md border-l-[3px] 2xl:border-l-[4px] border-blue-400 bg-blue-100 shadow cursor-pointer hover:shadow-md'
    }

    const OnTrainingPeaksWorkoutClicked = () => {

        const trainingPeaksMappingAssignerCoachId = trainingPeaksWorkout.trainingPeaksMappingAssignerCoachId
        
        if (parseInt(userId) !== parseInt(trainingPeaksMappingAssignerCoachId)) {
            ShowModal({
                key: ModalKey.Text,
                size: 'quarter',
                titleText: 'Unable to open TrainingPeaks calendar',
                bodyText: [
                    'This athlete\'s TrainingPeaks connection was not setup by you, therefore we are unable to open the TrainingPeaks calendar.',
                    'Please contact us at support@kinesisintegrated.com for more information.'
                ],
                buttonText: 'Close',
                buttonAction: () => {}
            })
            return
        }

        window.open(trainingPeaksWorkout?.Url ?? 'https://app.trainingpeaks.com', '_blank', 'noopener,noreferrer')
    }

    return (
        <div
            className={GetTailwindCssClassName()}
            onClick={OnTrainingPeaksWorkoutClicked}
            title={trainingPeaksWorkout.Title}
        >
            <div 
                className={`
                    flex min-w-0 gap-x-0.5 
                    ${timescale === 'week' ? 'items-start' : 'items-center'}
                `}
            >
                <img
                    src={trainingPeaksAppIcon}
                    alt='TrainingPeaks'
                    className='p-[1px] h-4 w-4 shrink-0 rounded-sm'
                />

                <div 
                    className={`
                        min-w-0 flex-1 text-xxs 2xl:text-xs font-medium 
                        ${timescale === 'week' ? 'whitespace-normal break-words' : 'truncate'}
                    `}
                >
                    {trainingPeaksWorkout.Title}
                </div>
            </div>
        </div>
    )
}
